import ReactEcharts from "echarts-for-react";
import React from "react";
import {BrowserRouter as Router, Switch} from "react-router-dom";

const DealersByActivity = ({
                         data
                     }) => {


    const dateOptions = {
        title: {
            text: 'Dealer Login Activity'
        },
        tooltip: {
            trigger: 'axis'
        },
        toolbox: {
            feature: {
                saveAsImage: {}
            }
        },
        xAxis: {
            type: 'category',
            data: Object.keys(data.active_dealers)
        },
        yAxis: {
            type: 'value'
        },
        series: [
            {
                data: Object.values(data.active_dealers),
                type: 'line'
            }
        ]
    };

    return (
        <Router>
            <Switch>
                <ReactEcharts
                    option={dateOptions}
                    style={{ width: "600px", height: "300px" }}
                ></ReactEcharts>
            </Switch>
        </Router>
    );
};

export default DealersByActivity;